import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PrivateRoute({ children }) {
  const { currentUser, userRole, userStatus } = useAuth();

  // If not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If user is pending approval and they registered after the new system
  if (userRole === 'pending' && userStatus === 'pending') {
    return <Navigate to="/pending-approval" replace />;
  }

  // If user is approved or is a legacy user (no status), allow access
  return children;
} 